import type { SowDocumentRow, SowTemplateType } from '../types';

export const SOW_TEMPLATE_LABELS: Record<SowTemplateType, string> = {
  coaching_sow: 'Coach scope · Coaching',
  cohort_contract: 'Client SOW · Cohort',
  exec_coaching_sow: 'Client SOW · Executive Coaching',
  executive_partner_sow: 'Coach scope · Executive Partner',
};

export function filterSowDocuments(docs: SowDocumentRow[], template: string, query: string): SowDocumentRow[] {
  const needle = query.trim().toLowerCase();
  return docs.filter((doc) => (template === 'all' || doc.templateType === template) &&
    (!needle || [doc.opportunityNumber, doc.accountName, doc.opportunityName, doc.fileName].some((v) => v?.toLowerCase().includes(needle))));
}

export function sowEditorUrl(opportunityId: string, template: SowTemplateType): string {
  return `/sow/${encodeURIComponent(opportunityId)}?template=${template}`;
}
